import {atom} from "recoil";

/**
 * 클릭한 버그 문서
 * @type {RecoilState<number>}
 */
export const bugDocState = atom({
    key: "bugDocState"
    , default: 0
})